<template>
  <div>
    <div class="row">
      <div class="col-md-10"></div>
      <div class="col-md-2"></div>
    </div>
    <reload v-if="reload_hab"></reload>
    <div class="col-md-12">
      <h4>Pedido de Troca de Senha</h4>
    </div>
    
    <div class="col-md-12" >
      <g-recaptcha :sitekey='sitekey' :callback="callback" style="margin-bottom: 10px;" ></g-recaptcha> 
      <button
        type="button"
        class="btn btn-primary btn-fill float-left"
        @click.prevent="editarSenha"
      >Enviar pedido de senha</button>
    </div> 
  </div>
</template>

<script>
import store_cidadao from "src/storeCidadao.js"
import "src/controller/sistema/manifestacaoController.js";
import "src/controller/sistema/assuntoSecretariaController.js";
import "src/controller/sistema/usuarioController.js";
import "src/controller/sistema/cidadaoController.js";
import gRecaptcha from 'src/components/recaptcha.vue'
import Reload from "src/components/Reload-v1.vue";

export default {
  name: "perfilcidadao",
  components: {gRecaptcha,Reload},
  props: {
    email: null,
  },
  data() {
    return {
      sitekey: '6LctowIaAAAAAEIUAiug_2YU7EGwnaE1a82a_W_t',
      token: null,
      novoemail:null,
      reload_hab: false,
    };
  },
  methods: {
    callback(token){
      this.token = token;
    },
    async editarSenha(){
       try {
          grecaptcha.reset();
          this.reload_hab = true;
          let data = await this.$trocarSenhaLogin(this.novoemail,this.token);
          this.reload_hab = false;
          this.$alert("Um E-mail foi enviado para realizar a troca de senha.");
          this.$router.push({name: 'meuperfil'} );
       } catch (e) {
         console.log(e);
       }
    },
  },
  beforeMount() {
    try {
      this.novoemail = this.email;
    } catch (e) {}
  },
};
</script>

